import React from 'react';
import WidgetGeneratingForm from './WidgetGeneratingForm';
import './styles.scss';
import useTranslation from 'hooks/useTranslation';

const WidgetGeneratingCard = (props) => {
  const { getTranslation } = useTranslation('COMMON');
  const { t } = getTranslation();

  return (
    <div className='signup_box'>
      <h4>{t('WIDGET_GENERATION_CARD').TITLE}</h4>
      <p className='description'>{t('WIDGET_GENERATION_CARD').DESCRIPTION}</p>
      <WidgetGeneratingForm />
    </div>
  );
};

export default WidgetGeneratingCard;
